import React, { PureComponent } from "react";
import { Row, Col, Container } from "react-bootstrap";

import RegisterVendorForm from "./RegisterVendorForm";
import { BidsAgreements } from "storefront/features/shared";

export default class RegisterVendor extends PureComponent {
  render() {
    return (
      <Container>
        <Row className="justify-content-center my-5">
          <Col className="m-5 text-center col-md-6 col-10">
            <h1>VENDOR REGISTER</h1>
            <RegisterVendorForm />
            <BidsAgreements termsAndConditionsLink="" privacyPolicy="" />
          </Col>
        </Row>
      </Container>
    );
  }
}
